import * as actionTypes from '../types/stockConfigure';

export function getStockConfigureList(payload) {
  return {
    type: actionTypes.GET_STOCK_CONFIGURE_LIST,
    payload
  };
}

export function getStockConfigureListSuccess(payload) {
  return {
    type: actionTypes.GET_STOCK_CONFIGURE_LIST_SUCCESS,
    payload
  };
}

export function getStockConfigureListFail(payload) {
  return {
    type: actionTypes.GET_STOCK_CONFIGURE_LIST_FAIL,
    payload
  };
}

export function addNewStockLevel(payload) {
  return {
    type: actionTypes.ADD_NEW_STOCK_LEVEL,
    payload
  };
}

export function addNewStockLevelSuccess(payload) {
  return {
    type: actionTypes.ADD_NEW_STOCK_LEVEL_SUCCESS,
    payload
  };
}

export function addNewStockLevelFail(payload) {
  return {
    type: actionTypes.ADD_NEW_STOCK_LEVEL_FAIL,
    payload
  };
}

export function deleteStockLevel(payload) {
  return {
    type: actionTypes.DELETE_STOCK_LEVEL,
    payload
  };
}

export function deleteStockLevelSuccess(payload) {
  return {
    type: actionTypes.DELETE_STOCK_LEVEL_SUCCESS,
    payload
  };
}

export function deleteStockLevelFail(payload) {
  return {
    type: actionTypes.DELETE_STOCK_LEVEL_FAIL,
    payload
  };
}
